import { useEffect } from "react";

/**
 * Injects a `<script type="application/ld+json">` block into <head> with the
 * supplied structured-data payload and removes it on unmount / route change.
 *
 * Pass `null` or `undefined` to render nothing. Re-renders update the same
 * tag in place rather than churning new DOM nodes.
 */
export default function useJsonLd(payload, key) {
  useEffect(() => {
    if (!payload) return undefined;
    const id = `ld-${key || "page"}`;
    let tag = document.getElementById(id);
    if (!tag) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = id;
      document.head.appendChild(tag);
    }
    tag.text = JSON.stringify(payload);
    return () => {
      const stale = document.getElementById(id);
      if (stale) stale.remove();
    };
  }, [payload, key]);
}
